import EventElement from '../types/event-element';
import OneWayOffer from '../types/one-way-offer';

export function isOneWayOffer(el: EventElement): el is OneWayOffer {
  return !!(el as OneWayOffer).offerStatus;
}
